export default __webpack_public_path__ + "static/media/img-1.b7d72d0d.jpg";